import { postInternalAdminRequest } from "@/features/internal-admin/api";

export const ACCOUNT_MEMBERSHIPS_CHANGED_EVENT = "skyharbor:account-memberships-changed";

export function syncAccountOrganizationMemberships(
  authData: unknown
): Promise<{ changed: boolean }> {
  return postInternalAdminRequest("/api/users/sync_organization_memberships", authData, {});
}
